module.exports = __webpack_public_path__ + "static/media/web.27c2982f.png";